import * as React from "react";
const SvgFiRrToiletPaperBlankUnder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-toilet-paper-blank-under_svg__a)">
      <path
        fill="#062147"
        d="M22.259 18.858c-.227-.09-.297-.172-.269-1.293.005-.183.01-9.065.01-9.065C22 3.733 19.804 0 17 0H5C2.196 0 0 3.733 0 8.5S2.196 17 5 17h3v2c0 2.757 2.243 5 5 5h8.347A2.656 2.656 0 0 0 24 21.346c0-1.088-.684-2.065-1.741-2.488M20 8.5c0 3.831-1.581 6.5-3 6.5s-3-2.669-3-6.5S15.581 2 17 2s3 2.669 3 6.5m-18 0C2 4.669 3.581 2 5 2h8.745C12.672 3.547 12 5.866 12 8.5s.671 4.953 1.745 6.5H5c-1.419 0-3-2.669-3-6.5M21.347 22H13c-1.654 0-3-1.346-3-3v-2h7c1.135 0 2.17-.612 3-1.655 0 0-.005 2.003-.009 2.17-.028 1.083-.066 2.566 1.525 3.202.233.093.483.308.483.63 0 .36-.293.654-.653.654zM17 7c.552 0 1 .672 1 1.5s-.448 1.5-1 1.5-1-.672-1-1.5.448-1.5 1-1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-toilet-paper-blank-under_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToiletPaperBlankUnder;
